import {
  GET_FEE_INVALID_REQUEST,
  GET_FEE_FAILED,
  GET_FEE_SUCCESS,
  GET_FEE_NOT_FOUND,
  LOADING_GET_FEE,
  GET_FEE_NOT_EXISTS,
  RESET_GET_FEE,
} from "../types";

const initialState = {
  isLoading: false,
  success: false,
  error: false,
  notFound: false,
  transactionType: "",
  data: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_GET_FEE:
      return {
        ...state,
        isLoading: true,
        success: false,
        error: false,
        notFound: false,
      };

    case GET_FEE_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        error: true,
        notFound: false,
      };
    case GET_FEE_INVALID_REQUEST:
      return {
        ...state,
        isLoading: false,
        success: false,
        error: true,
        notFound: false,
      };

    case GET_FEE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        error: false,
        notFound: false,
        transactionType: action.payload.transactionType,
        data: [].concat(action.payload.fee),
      };

    case GET_FEE_NOT_EXISTS:
      return {
        ...state,
        isLoading: false,
        success: false,
        notFound: false,
        error: true,
      };

    case GET_FEE_NOT_FOUND:
      return {
        ...state,
        isLoading: false,
        success: false,
        notFound: true,
        error: false,
      };

    case RESET_GET_FEE:
      return (state = initialState);

    default:
      return state;
  }
};
